


export async function delay(delayMs:number) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, delayMs)
  });
}

export function extractTextContentFromHTML(html) {
  // For zoomtest domain, skip parsing to prevent XSS during DOMParser
  if (typeof window !== 'undefined' && 
      window.location.hostname.includes('zoomtest.onlinecoursehost.com')) {
    // Return plain text without parsing (avoid XSS)
    return html.replace(/<[^>]+>/g, ''); // Simple regex strip for safety
  }
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  function traverse(node) {
    let result = '';

    // Exclude script and style nodes
    if (node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE') {
      return result;
    }

    // Extract text from text nodes
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent;
    }
    // Traverse child nodes
    else if (node.childNodes && node.childNodes.length > 0) {
      for (let i = 0; i < node.childNodes.length; i++) {
        result += traverse(node.childNodes[i]);
      }
    }

    return result;
  }

  return traverse(doc.body);
}

